import websitePage from '../../../../hoc/websitePage/websitePage';
import FAQSEO from '../../../../components/FAQSEO/FAQSEO';
import QuestionPage from '../../../../screens/FAQ/patterns/QuestionPage/QuestionPage';
import { getAllQuestionPageContent, getQuestionsSlugs } from '../../../../service/cms/getQuestionPageContent';

export async function getStaticPaths() {
  const allQuestions = await getQuestionsSlugs();

  const paths = allQuestions.map(question => ({
    params: {
      category: question.category.slug,
      question: question.slug,
    },
  }));

  return {
    paths,
    fallback: false,
  };
}

export const getStaticProps = async context => {
  const {
    question, categories, questions, allQuestions,
  } = await getAllQuestionPageContent(context.params.question);

  return {
    props: {
      cmsMessages: {
        seo: {
          contentType: 'question',
          description: question.shortAnswer,
          title: question.question,
        },
        question,
        categories,
        questions,
        allQuestions,
      },
    },
  };
};

export default websitePage(QuestionPage, { seoComponent: FAQSEO });
